import { httpRequest } from "@services/http";

/** A JourneyStepDimension declared on a step — the pickable pricing cells. */
export interface JourneyStepDimensionOption {
  id: number;
  code: string;
  name: string;
  sequence: number;
}

export class CommandListObservedDimensions {
  async run(
    contractId: number,
    pricesheetId: number,
    stepId: number,
  ): Promise<JourneyStepDimensionOption[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/journey-steps/${stepId}/observed-dimensions/`;
    return await httpRequest<JourneyStepDimensionOption[]>(url, { method: "GET" });
  }
}
